import { ReportStatus, ReportType } from './report.model';


export interface Person {
    name: string;
    lastName: string;
}

export interface Client extends Person {
    email: string;
}

export interface Payer extends Person {
    street:string;
    postalCode: string;
    city: string;
    email: string;
}

export interface Deceased extends Person {
    peselNumber: string;
    taxId: string;
    dateOfDeath: Date;
}


export interface Consent {
    termsAndConditions:boolean;
    verificationOfTheDeceased:boolean;
    consentToElectronicCommunications:boolean;
    marketingAgreement:boolean;
    immediateExecution:boolean;
}


export interface OrderRequest {
    product:ReportType;
    client:Client;
    payer: Payer;
    deceased:Deceased;
    consent:Consent;
    relationToDeceased:RelationToDeceased;
}

export interface OrderResponse {
    paymentGateway: string;
    paymentId: string;
    redirectUri: string;
    token: string;
}

export interface Order {
    client: Client;
    payer: Payer,
    deceased: Deceased;
    consent: Consent;
    createdAt: Date;
    updatedAt: Date;
    status: OrderStatus;
    product: {
      type: ReportType;
      name: string;
      description: string;
      price: {
        currency: string;
        amount: number;
        taxRatePercentage: number
        priceIncludesTax: boolean;
      },
      publicName: string;
    }
    payment: {
        dateCreated: Date;
        dateUpdated: Date;
        paymentId: string;
        status: PaymentStatus
        amount: number;
        currency: string;
        paymentGateway: string;
    }
    orderNumber:string;
    relationToDeceased: RelationToDeceased;
    report: {
        token: string;
        status: ReportStatus;
    }


}


export type PaymentStatus =  'CREATED' | 'SUBMITTED' | 'COMPLETED' | 'FAILED' | 'CANCELED';
export enum PaymentStatuses {
    CREATED ='CREATED',
    SUBMITTED ='SUBMITTED',
    COMPLETED = 'COMPLETED',
    FAILED = 'FAILED',
    CANCELED = 'CANCELED'
}

export enum OrderStatus {
  CREATED = 'CREATED',
  SUBMITTED = 'SUBMITTED',
  PROCESSING = 'PROCESSING',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  CANCELED = 'CANCELED',
}

export enum RelationToDeceased {
  NON_RELATED = 'NON_RELATED', // Osoba niespokrewniona
  SPOUSE = 'SPOUSE', // Małżonek
  CHILD = 'CHILD', // Dziecko (syn lub córka)
  PARENT = 'PARENT', // Rodzic (ojciec lub matka)
  SIBLING = 'SIBLING', // Rodzeństwo (brat lub siostra)
  GRANDPARENT = 'GRANDPARENT', // Dziadkowie (babcia lub dziadek)
  GRANDCHILD = 'GRANDCHILD', // Wnuki (wnuk lub wnuczka)
  AUNT_OR_UNCLE = 'AUNT_OR_UNCLE', // Wuj lub ciotka
  PATERNAL_AUNT_OR_UNCLE = 'PATERNAL_AUNT_OR_UNCLE', // Stryj lub stryjenka
  NEPHEW_NIECE_PATERNAL = 'NEPHEW_NIECE_PATERNAL', // Bratanek lub bratanica
  NEPHEW_NIECE_MATERNAL = 'NEPHEW_NIECE_MATERNAL', // Siostrzeniec lub siostrzenica
  OTHER_RELATIVE = 'OTHER_RELATIVE', // Inny krewny (dalszy krewny)
  STEPCHILD = 'STEPCHILD', // Pasierb lub pasierbica
  SUCCESSION_ADMINISTRATOR = 'SUCCESSION_ADMINISTRATOR', // Zarządca sukcesyjny
  EXECUTOR_OF_WILL = 'EXECUTOR_OF_WILL', // Wykonawca testamentu
}
